import { ApiCredentialsTypesEnum } from "dash-common";

export enum CreateUserFormFields {
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Password = "password",
  ExcludeFromReports = "excludeFromReports",
  ReferralCode = "referralCode",
  CompanyName = "companyName",
}

export const CreateUserFormFieldsList = [
  CreateUserFormFields.FirstName,
  CreateUserFormFields.LastName,
  CreateUserFormFields.Email,
  CreateUserFormFields.Password,
  CreateUserFormFields.ExcludeFromReports,
  CreateUserFormFields.ReferralCode,
  CreateUserFormFields.CompanyName,
];

export const API_PLUGIN_USER_LINK = `${process.env["REACT_APP_BROKER_PORTAL_URL"]}/auth/sign-up?api-referral=`;
